import { CheckCircleIcon, ExclamationCircleIcon } from '@heroicons/react/24/solid'

const VerificationStep = ({ title, children, isComplete, isPending }) => {
  const renderStatus = () => {
    if (isPending) {
      return (
        <span className="text-yellow-600 font-medium flex items-center gap-1">
          <ExclamationCircleIcon className="w-6 h-6" /> In Review
        </span>
      )
    }

    if (isComplete) {
      return (
        <span className="text-green-600 font-medium flex items-center gap-1">
          <CheckCircleIcon className="w-6 h-6" /> Done
        </span>
      )
    }

    return (
      <span className="text-gray-600 font-medium flex items-center gap-1">
        <ExclamationCircleIcon className="w-6 h-6" /> Incomplete
      </span>
    )
  }

  return (
    <div className="border rounded-lg p-4 shadow-sm bg-background space-y-2">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">{title}</h2>
        <div className="flex items-center space-x-2">{renderStatus()}</div>
      </div>
      <div>{children}</div>
    </div>
  )
}

export default VerificationStep
